import { Dialog, Box, Grid2, TextField, Typography, IconButton, Select, MenuItem, Autocomplete, Snackbar, Alert, snackbarClasses, Button } from "@mui/material";
import { useEffect, useState } from "react";
import CustomRadioButton from "../button/CustomRadioButton";
import { AdapterDayjs, CloseRoundedIcon, CustomConfirmDialog, DatePicker, dayjs, LocalizationProvider, Toaster, useApi, validationMessages } from "../../utils/globalImports";
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import ViewInArOutlinedIcon from '@mui/icons-material/ViewInArOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CheckIcon from '@mui/icons-material/Check';
import { InputAdornment } from '@mui/material';
import { Euro } from "@mui/icons-material";
interface SubStageModalProps {
    row: any;
    open: boolean;
    onClose: () => void;
    feeStageIdProp: number;
    FetchFeeStages: any;
    AlreadyExists?: any;
    isToggle: boolean;
    setToggle: React.Dispatch<React.SetStateAction<boolean>>;
}
interface AreaName {
    id: number,
    label: string
}
const CustomSubStageModal: React.FC<SubStageModalProps> = ({
    row,
    open,
    onClose,
    feeStageIdProp,
    FetchFeeStages,
    AlreadyExists,
    isToggle,
    setToggle
}) => {

    const { execute } = useApi()
    const [toast, setToast] = useState({ open: false, message: "", type: "success" });
    const [AreaOptions, setAreaOptions] = useState<AreaName[]>([])

    const [formData, setFormData] = useState({
        subStageName: "",
        startDate: "",
        endDate: "",
        currentCost: "",
        revisedCost: "",
        status: "Active",
        FeeStageAreaId: 0,
        madeInIndia: 0
    });


    const AddSubFeeStage = async (isToggleUpdate: boolean = false) => {
        try {
            debugger;
            const payload = {
                feeStageID: feeStageIdProp,
                subStageName: formData.subStageName?.trim(),
                currentCost: Number(formData.currentCost),
                revisedCost: Number(formData.revisedCost),

                startDate: formData.startDate
                    ? new Date(formData.startDate).toISOString()
                    : null,

                endDate: formData.endDate
                    ? new Date(formData.endDate).toISOString()
                    : null,

                feeSubStageAreaID: formData.FeeStageAreaId,
                completedByIndia: formData.madeInIndia,
                status: isToggleUpdate ? formData.status === "Active" ? 0 : 1 : formData.status === "Active" ? 1 : 0,

                ...(row?.id > 0 && { id: row.id })
            };

            if (
                !payload.subStageName ||
                payload.feeSubStageAreaID == null ||
                payload.feeSubStageAreaID <= 0 ||
                payload.completedByIndia == null ||
                payload.completedByIndia < 0 || payload.currentCost < 0 || payload.revisedCost < 0
            ) {

                setToast({
                    open: true,
                    message: (() => {
                        switch (true) {
                            case !payload.subStageName:
                                return "Sub Stage Name is required";

                            case payload.feeSubStageAreaID == null ||
                                payload.feeSubStageAreaID <= 0:
                                return "Fee Substage Area is required";

                            case payload.completedByIndia == null ||
                                payload.completedByIndia < 0:
                                return "Made In India is required";

                            case payload.currentCost < 0:
                                return "Current Cost is required and must be a positive number";

                            case payload.revisedCost < 0:
                                return "Revised Cost is required and must be a positive number";

                            default:
                                return "Validation failed";
                        }
                    })(),
                    type: "error"
                });
                return;
            }
            if (payload?.startDate && payload?.endDate && payload.startDate > payload.endDate) {
                setToast({
                    open: true,
                    message: "Start date must be before end date",
                    type: "error"
                });
                return;
            }

            if(AlreadyExists(payload.subStageName)){
                setToast({
                    open: true,
                    message: "A Sub Stage with this name already exists",
                    type: "error"
                });
                return;
            }
            const { data } = await execute<boolean>(
                "post",
                "Proposal/SubFeeStage",
                payload
            );

            if (data === true) {
                setToast({
                    open: true,
                    message:
                        row?.id == null
                            ? "Added Successfully"
                            : "Updated Successfully",
                    type: "success"
                });

                FetchFeeStages();
                setTimeout(() => {
                    onClose();
                    setToggle(false);
                }, 1000)
            } else {
                setToast({
                    open: true,
                    message: "Operation failed",
                    type: "error"
                });
            }
        } catch (error) {
            console.error("API Error:", error);

            setToast({
                open: true,
                message: "Something went wrong",
                type: "error"
            });
        }
    };

    const formatDate = (value: any) => {
        if (!value) return "";
        const d = dayjs(value, "DD/MM/YYYY");
        return d.isValid() ? d.format("YYYY-MM-DD") : "";
    };

    useEffect(() => {
        if (row) {
            setFormData({
                subStageName: row.subStageName ?? "",
                startDate: formatDate(row.startDate),
                endDate: formatDate(row.endDate),
                currentCost: row.currentCost ?? "",
                revisedCost: row.revisedCost ?? "",
                status: row.status == 0 ? "Inactive" : "Active",
                FeeStageAreaId: row.feeSubStageAreaID ?? 0,
                madeInIndia: row.completedByIndia === "No" ? 0 : 1
            });
        } else {
            setFormData({
                subStageName: "",
                startDate: "",
                endDate: "",
                currentCost: "",
                revisedCost: "",
                status: "Active",
                FeeStageAreaId: 0,
                madeInIndia: -1
            });
        }
    }, [row]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const GetFeeStageArea = async () => {
        const { data } = await execute<any>(
            'get',
            'LookUp/GetFeeStageAreaNames'
        )
        const formatted = (data || []).map((item: any) => ({
            id: item.feeStageAreaNameId,
            label: item.feeStageAreaName
        }));
        setAreaOptions(formatted);
    }

    useEffect(() => {
        debugger;
        GetFeeStageArea();
    }, [])


    const madeInIndiaOptions = [
        { id: 1, label: "Yes" },
        { id: 0, label: "No" },
    ];

    return (
        isToggle ?
            (
                <>
                    <CustomConfirmDialog
                        open={open}
                        title={formData.status === "Active" ? "Deactivate Sub Stage" : "Activate Sub Stage"}
                        message={validationMessages.SubFeeStage_Confirm(formData.status === "Active" ? "Inactive" : "Active")}
                        onConfirm={() => { AddSubFeeStage(true) }}
                        onCancel={() => {
                            setToggle(false)
                        }}
                        onClose={() => {
                            setToggle(false)
                        }}

                    />
                    <Toaster
                        open={toast.open}
                        message={toast.message}
                        type={toast.type as "success" | "error"}
                        onClose={() => setToast({ ...toast, open: false })}
                    />
                </>
            ) : (
                <Dialog
                    open={open}
                    onClose={(event, reason) => {
                        if (reason === "backdropClick") return;
                        onClose();
                    }}
                    maxWidth="md"
                    fullWidth
                    PaperProps={{
                        sx: {
                            borderRadius: 3,
                            boxShadow: "0px 10px 30px rgba(0,0,0,0.1)",
                        },
                    }}
                >
                    <Box p={3} position="relative">

                        {/* ── Header ── */}
                        <Box display="flex" alignItems="flex-start" mb={3}>
                            <Box
                                sx={{
                                    width: 48, height: 48, borderRadius: "50%",
                                    backgroundColor: "#e8f5e9",
                                    display: "flex", alignItems: "center", justifyContent: "center",
                                    mr: 1.5, flexShrink: 0,
                                }}
                            >
                                <RequestQuoteOutlinedIcon sx={{ color: "#7cb342", fontSize: 26 }} />
                            </Box>
                            <Box>
                                <Typography sx={{ fontSize: "20px", fontWeight: 700, color: "#1a1a1a" }}>
                                    {row ? "Update Sub Fee Stage" : "Add Sub Fee Stage"}
                                </Typography>
                                <Typography sx={{ fontSize: "12px", color: "#888", mt: 0.3 }}>
                                    {row
                                        ? "Update the details of the sub fee stage."
                                        : "Fill in the details below to add a new sub fee stage."}
                                </Typography>
                            </Box>
                            <IconButton
                                onClick={onClose}
                                sx={{ ml: "auto", color: "#aaa", "&:hover": { color: "#555" } }}
                            >
                                <CloseRoundedIcon fontSize="small" />
                            </IconButton>
                        </Box>

                        {/* ── Form Fields ── */}
                        <Grid2 container spacing={2}>

                            {/* Row 1: Sub Fee Stage Name, Start Date, End Date */}
                            <Grid2 size={4}>
                                <Typography sx={{ fontSize: "12px", fontWeight: 600, mb: 0.5 }}>
                                    Sub Fee Stage Name <span style={{ color: "red" }}>*</span>
                                </Typography>
                                <TextField
                                    fullWidth
                                    name="subStageName"
                                    size="small"
                                    placeholder="Enter sub fee stage name"
                                    value={formData.subStageName}
                                    onChange={handleChange}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <LabelOutlinedIcon sx={{ fontSize: 18, color: "#aaa" }} />
                                            </InputAdornment>
                                        ),
                                        sx: { borderRadius: "8px" },
                                    }}
                                />
                            </Grid2>

                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <Grid2 size={4}>
                                    <Typography sx={{ fontSize: "12px", fontWeight: 600, mb: 0.5 }}>
                                        Start Date <span style={{ color: "red" }}>*</span>
                                    </Typography>
                                    <DatePicker
                                        format="DD/MM/YYYY"
                                        value={formData.startDate ? dayjs(formData.startDate) : null}
                                        onChange={(newValue) => {
                                            setFormData((prev) => ({
                                                ...prev,
                                                startDate: newValue ? newValue.format("YYYY-MM-DD") : "",
                                            }));
                                        }}
                                        slotProps={{
                                            textField: {
                                                fullWidth: true,
                                                size: "small",
                                                placeholder: "Select start date",
                                                sx: {
                                                    "& .MuiOutlinedInput-root": { borderRadius: "8px" },
                                                },
                                            },
                                        }}
                                    />
                                </Grid2>

                                <Grid2 size={4}>
                                    <Typography sx={{ fontSize: "12px", fontWeight: 600, mb: 0.5 }}>
                                        End Date <span style={{ color: "red" }}>*</span>
                                    </Typography>
                                    <DatePicker
                                        format="DD/MM/YYYY"
                                        value={formData.endDate ? dayjs(formData.endDate) : null}
                                        onChange={(newValue) => {
                                            setFormData((prev) => ({
                                                ...prev,
                                                endDate: newValue ? newValue.format("YYYY-MM-DD") : "",
                                            }));
                                        }}
                                        slotProps={{
                                            textField: {
                                                fullWidth: true,
                                                size: "small",
                                                placeholder: "Select end date",
                                                sx: {
                                                    "& .MuiOutlinedInput-root": { borderRadius: "8px" },
                                                },
                                            },
                                        }}
                                    />
                                </Grid2>
                            </LocalizationProvider>

                            {/* Row 2: Current Cost, Revised Cost, Fee Stage Area, Made In India */}
                            <Grid2 size={4}>
                                <Typography sx={{ fontSize: "12px", fontWeight: 600, mb: 0.5 }}>
                                    Current Cost
                                </Typography>
                                <TextField
                                    fullWidth
                                    size="small"
                                    name="currentCost"
                                    type="number"
                                    placeholder="Enter Current Cost"
                                    value={formData.currentCost}
                                    onChange={handleChange}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Typography variant="h6" color="grey">
                                                £
                                                </Typography>
                                            </InputAdornment>
                                        ),
                                        sx: { borderRadius: "8px" },
                                    }}
                                />
                            </Grid2>

                            <Grid2 size={4}>
                                <Typography sx={{ fontSize: "12px", fontWeight: 600, mb: 0.5 }}>
                                    Revised Code
                                </Typography>
                                <TextField
                                    fullWidth
                                    size="small"
                                    name="revisedCost"
                                    type="number"
                                    placeholder="Enter Revised Cost"
                                    value={formData.revisedCost}
                                    onChange={handleChange}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                            <Typography variant="h6" color="grey">
                                                £
                                                </Typography>
                                            </InputAdornment>
                                        ),
                                        sx: { borderRadius: "8px" },
                                    }}
                                />
                            </Grid2>

                            <Grid2 size={4}>
                                <Typography sx={{ fontSize: "12px", fontWeight: 600, mb: 0.5 }}>
                                    Fee Stage Area
                                </Typography>
                                <Autocomplete
                                    options={AreaOptions}
                                    getOptionLabel={(option) => option.label}
                                    value={AreaOptions.find((a) => a.id === formData.FeeStageAreaId) || null}
                                    onChange={(event, newValue) => {
                                        setFormData((prev) => ({
                                            ...prev,
                                            FeeStageAreaId: newValue ? newValue.id : 0,
                                        }));
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Select Fee Stage Area"
                                            size="small"
                                            InputProps={{
                                                ...params.InputProps,
                                                startAdornment: (
                                                    <>
                                                        <InputAdornment position="start">
                                                            <ViewInArOutlinedIcon sx={{ fontSize: 18, color: "#7cb342" }} />
                                                        </InputAdornment>
                                                        {params.InputProps.startAdornment}
                                                    </>
                                                ),
                                                sx: { borderRadius: "8px" },
                                            }}
                                        />
                                    )}
                                />
                            </Grid2>
                            <Grid2 size={4}>
                                <Typography sx={{ fontSize: "12px", fontWeight: 600, mb: 0.5 }}>
                                    Made In India?
                                </Typography>
                                <Autocomplete
                                    options={madeInIndiaOptions}
                                    getOptionLabel={(option) => option.label}
                                    value={
                                        madeInIndiaOptions.find(
                                            (opt) => opt.id === formData.madeInIndia
                                        ) || null
                                    }
                                    onChange={(event, newValue) => {
                                        setFormData((prev) => ({
                                            ...prev,
                                            madeInIndia: newValue ? newValue.id : 0,
                                        }));
                                    }}
                                    sx={{ width: 200 }}
                                    renderInput={(params) => (
                                        <TextField {...params}  
                                        placeholder="Made in India?"
                                        size="small" />
                                    )}
                                />
                            </Grid2>
                            {/* Status Radio (edit mode only) */}
                            {row?.id != null && (
                                <Grid2 size={12} display="flex">
                                    <CustomRadioButton
                                        label="Active" value="Active" name="status"
                                        checked={formData.status === "Active"} onChange={handleChange}
                                    />
                                    <CustomRadioButton
                                        label="Inactive" value="Inactive" name="status"
                                        checked={formData.status === "Inactive"} onChange={handleChange}
                                    />
                                </Grid2>
                            )}

                            {/* ── Info Banner ── */}
                            <Grid2 size={12}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "flex-start",
                                        gap: 1.5,
                                        backgroundColor: "#e3f2fd",
                                        borderRadius: "10px",
                                        px: 2,
                                        py: 1.5,
                                    }}
                                >
                                    <InfoOutlinedIcon sx={{ color: "#1e66ab", fontSize: 20, mt: 0.2 }} />
                                    <Box>
                                        <Typography sx={{ fontSize: "13px", fontWeight: 700, color: "#1a1a1a" }}>
                                            Need help?
                                        </Typography>
                                        <Typography sx={{ fontSize: "12px", color: "#555" }}>
                                            Make sure all required fields are filled before saving.
                                        </Typography>
                                    </Box>
                                </Box>
                            </Grid2>

                        </Grid2>

                        {/* ── Footer Buttons ── */}
                        <Box mt={3} display="flex" justifyContent="flex-end" gap={1.5}>
                            <Button
                                variant="outlined"
                                onClick={onClose}
                                sx={{
                                    borderRadius: "8px",
                                    textTransform: "none",
                                    fontWeight: 500,
                                    color: "#555",
                                    borderColor: "#ccc",
                                    px: 3,
                                    "&:hover": { borderColor: "#aaa", backgroundColor: "#f5f5f5" },
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                onClick={() => AddSubFeeStage()}
                                startIcon={<CheckIcon />}
                                sx={{
                                    borderRadius: "8px",
                                    textTransform: "none",
                                    fontWeight: 600,
                                    backgroundColor: "#8bc34a",
                                    "&:hover": { backgroundColor: "#7cb342" },
                                    px: 3,
                                }}
                            >
                                {row ? "Update" : "Save"}
                            </Button>
                        </Box>

                    </Box>

                    <Toaster
                        open={toast.open}
                        message={toast.message}
                        type={toast.type as "success" | "error"}
                        onClose={() => setToast({ ...toast, open: false })}
                    />
                </Dialog>
            )
    );
};

export default CustomSubStageModal;